// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TzPYk","select":"styles_select__2eaPD"};